import * as React from 'react';
import themePrimary from '../../styles/themePrimary';
import { Typography, makeStyles, useMediaQuery, Dialog, AppBar, IconButton, Toolbar, Slide } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import FullWidthButton, { FullWidthButtonProps, FullWidthButtonSize } from '../common/Buttons/FullWidthButton';
import { String_PayCheck_CreditCardButton, String_PayCheck_RoomChargeButton } from '../../utilities/StringHelper';
import { ElementDimensions } from '../../styles/ElementDimensions';

const useStyles = makeStyles({
    buttonContainer: {
        marginTop: ElementDimensions.margin20 + "px",
    },
    buttons: {
        marginTop: ElementDimensions.margin20 + "px",
        marginBottom: ElementDimensions.margin20 + "px",
    }
});

export type PaymentSelectionCompleteHandler = (roomCharge: boolean) => any;

export interface PaymentSelectionProps {
    onCompleteHandler: PaymentSelectionCompleteHandler;
}

const PaymentSelection = (props: PaymentSelectionProps) => {
    const isPortrait = true;
    const { onCompleteHandler } = props;
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const handleCreditButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        onCompleteHandler(false)
    }

    const creditButtonProps: FullWidthButtonProps = {
        disabled: false,
        label:String_PayCheck_CreditCardButton.find(s => s.key === userState.state.locale)!!.value,
        alternateColor: false,
        size: FullWidthButtonSize.Large,
        onClickHandler: handleCreditButtonClick,
    }

    const handleRoomChargeButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        onCompleteHandler(true)
    }

    const roomChargeProps: FullWidthButtonProps = {
        disabled: false,
        label: String_PayCheck_RoomChargeButton.find(s => s.key === userState.state.locale)!!.value,
        alternateColor: false,
        size: FullWidthButtonSize.Large,
        onClickHandler: handleRoomChargeButtonClick,
    }

    return (
        <div className={classes.buttonContainer}>
            <div className={classes.buttons}>
                <FullWidthButton 
                    disabled={creditButtonProps.disabled}
                    label={creditButtonProps.label}
                    alternateColor={creditButtonProps.alternateColor}
                    size={creditButtonProps.size}
                    onClickHandler={creditButtonProps.onClickHandler}/>
            </div>
            <div className={classes.buttons}>
                <FullWidthButton 
                    disabled={roomChargeProps.disabled}
                    label={roomChargeProps.label}
                    alternateColor={roomChargeProps.alternateColor}
                    size={roomChargeProps.size}
                    onClickHandler={roomChargeProps.onClickHandler}/>
            </div>
        </div>
    );
};

export default PaymentSelection;